import { withPageProps } from '@airship-platform/airship-patterns';
import { Navigate, Route, Routes } from 'react-router';
import ProposalTemplatesHistoryDetailPage from './history/ProposalTemplatesHistoryDetailPage';
import ProposalTemplatesHistoryQuery from './history/ProposalTemplatesHistoryQuery';
import ProposalTemplateOptionQuery from './options/ProposalTemplateOptionQuery';
import ProposalTemplateDetailOptionView from './proposals/ProposalTemplateDetailOptionView';
import ProposalTemplateDetailPage from './proposals/ProposalTemplateDetailPage';
import ProposalTemplatesQuery from './proposals/ProposalTemplatesQuery';
import ProposalTemplatesView from './ProposalTemplatesView';

const addPageProps = (comp: React.FC, title: string) =>
  withPageProps(comp, { title });

const proposalTemplatesQuery = addPageProps(
  ProposalTemplatesQuery,
  'Proposal Templates'
);

const proposalTemplateOptionQuery = addPageProps(
  ProposalTemplateOptionQuery,
  'Proposal Template Options'
);

const proposalTemplatesHistoryQuery = addPageProps(
  ProposalTemplatesHistoryQuery,
  'Proposal Templates History'
);

const proposalTemplateDetailOptionView = addPageProps(
  ProposalTemplateDetailOptionView,
  'Proposal Template Detail Option'
);

const proposalTemplatesHistoryDetailPage = addPageProps(
  ProposalTemplatesHistoryDetailPage,
  'Proposal Templates History Detail'
);

const ProposalTemplatesPage: React.FC = () => (
  <Routes>
    <Route path="/" Component={ProposalTemplatesView}>
      <Route index element={<Navigate to="proposals" replace={true} />} />
      <Route path="proposals" Component={proposalTemplatesQuery} />
      <Route path="options" Component={proposalTemplateOptionQuery} />
      <Route path="history" Component={proposalTemplatesHistoryQuery} />
    </Route>
    <Route
      path="proposals/:proposalTemplateId"
      Component={ProposalTemplateDetailPage}
    >
      <Route index Component={proposalTemplateDetailOptionView} />
      <Route
        path="option/:proposalTemplateOptionId"
        Component={proposalTemplateDetailOptionView}
      />
    </Route>
    <Route
      path="history/details"
      Component={proposalTemplatesHistoryDetailPage}
    />
  </Routes>
);

export default ProposalTemplatesPage;
